import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../layout/footer.component';
import { ExternalDistributedReportsHeaderComponent } from './external-distributed-reports-header.component';

@Component({
  selector: 'app-external-distributed-reports-layout',
  imports: [
    RouterOutlet,
    ExternalDistributedReportsHeaderComponent,
    FooterComponent,
  ],
  template: ` <div
    class="tw-min-h-screen tw-flex tw-flex-col"
    style="padding-top: var(--header-height, 0px);"
  >
    <app-external-distributed-reports-header />

    <main
      id="main-content"
      role="main"
      class="tw-flex tw-justify-center tw-grow"
    >
      <div
        class="tw-max-w-[1300px] tw-flex-col tw-w-full tw-grow tw-px-4 sm:tw-px-8 tw-pt-4 "
      >
        <router-outlet></router-outlet>
      </div>
    </main>
    <app-footer [showWhatsNew]="false" [techSupportLiveChat]="true" />
  </div>`,
  styles: ``,
})
export class ExternalDistributedReportsLayoutComponent {}
